import React from 'react';
// import photoImg from '../../images/photo.png';
import photoImg from 'images/Paul Ryan.jpg';
import AnnPhotoImg from 'images/AnnKiely.jpg';
import NaomiPhotoImg from 'images/Naomi.png';
import AislingFarrellImg from 'images/Aisling Farrell.jpeg';
import EoinMurphyImg from 'images/EoinMurphy.jpg';

export default class AboutUs extends React.Component {

  render(){
    return (
      <section className="about-us section-center">
        <div className="section-center-wrapper">
          <div className="hero-block">
            <h4 className="subTitle">
              Since 2007, Prescription Revision has been helping over a thousand GP trainees to succeed
              in both their CCT and CKT MICGP Examinations. We are passionate about delivering key
              concepts on how to succeed in the MICGP exam. We use a range of different formats
              including podcasts, video and text to teach GP trainees.
            </h4>
          </div>
          <div className="container-fluid">
            <div className="row">
              <div className="info-block col-md-5">
                <div className="info-block-inner">
                  <img src={photoImg} alt="About Us" className='aboutImg' />
                  <p>
                    Paul Ryan is both a qualified pharmacist and a GP and has a passion for teaching. He completed a
                    postgraduate certificate in teaching and learning and is currently completing a MD. Paul
                    founded Prescription Revision in 2007.
                  </p>
                </div>
              </div>
              <div className="info-block col-md-5">
                <div className="info-block-inner">
                  <img src={AnnPhotoImg} alt="About Us" className='aboutImg' />
                  <p>
                    Ann Kiely is a vocationally trained GP and native of Belgooly, Co. Cork. She is a School of
                    Medicine Tutor, UCC since 2014. She graduated from Southwest GP Training Scheme in
                    2013 and UCC Medicine Class 2007. She has particular interests in Medical Education, Child
                    Health and Mental Health.
                  </p>
                </div>
              </div>
              <div className="info-block col-md-5">
                <div className="info-block-inner">
                  <img src={NaomiPhotoImg} alt="About Us" className='aboutImg' />
                  <p>
                    Naomi Smith is a UCD medicine (and neuroscience) graduate. She worked in hospital medicine for three years prior to returning to UCD for the GP training scheme. She serves on the board of Hyperemesis Ireland and loves teaching, learning and reading. She has two boisterous toddlers who keep me on my toes!
                  </p>
                </div>
              </div>
              <div className="info-block col-md-5">
                <div className="info-block-inner">
                  <img src={AislingFarrellImg} alt="About Us" className='aboutImg' />
                  <p>
                    Aisling Farrell is a GP and clinical lecturer in UCC. Aisling has a passion for research and education and has completed post graduate training in dermatology, exercise medicine, sports nutrition and lifestyle medicine. She sits on the educational advisory group for Cervical Check. She is currently completing post graduate training in teaching.
                  </p>
                </div>
              </div>
              <div className="info-block col-md-5">
                <div className="info-block-inner">
                  <img src={EoinMurphyImg} alt="About Us" className='aboutImg' />
                  <p>
                    Eoin Murphy is a Corkman and a UCC graduate from the class of 2016. He completed his Basic Specialist Training in Medicine in 2019 and qualified as a GP in 2024 from the Cork scheme. Outside of work, he's passionate about sports, keeping fit, and getting lost in a good book. Above all, he values quality time with his family.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/informations/AboutUs.js